import React, { useState, useEffect } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'

export interface CreditDinnerModalProps {
  open: boolean
  title?: string
  initialCoName?: string
  initialCustomerName?: string
  currencySymbol?: string
  onCancel: () => void
  onConfirm: (payload: { coName: string; customerName: string }) => void
}

export const CreditDinnerModal: React.FC<CreditDinnerModalProps> = ({
  open,
  title = 'Credit Dinner',
  initialCoName = '',
  initialCustomerName = '',
  currencySymbol = 'SAR',
  onCancel,
  onConfirm
}) => {
  const [coName, setCoName] = useState('')
  const [customerName, setCustomerName] = useState(initialCustomerName)

  useEffect(() => {
    if (open) {
      setCoName((initialCoName || '').trim())
      setCustomerName(initialCustomerName || '')
    }
  }, [open, initialCustomerName, initialCoName])

  if (!open) return null

  const submit = () => {
    const co = coName.trim()
    if (!co) return
    onConfirm({ coName: co, customerName: customerName.trim() })
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
          <button type="button" onClick={onCancel} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          A full (100%) discount is applied. Enter the care-of (C/o) name and customer name for Credit Dinner tracking ({currencySymbol} value is recorded on the order).
        </p>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">C/o Name *</label>
            <input
              type="text"
              value={coName}
              onChange={(e) => setCoName(e.target.value)}
              className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Care of name"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Customer name</label>
            <input
              type="text"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Guest or registered customer"
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={submit}
            disabled={!coName.trim()}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  )
}
